import { ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { resolveImageUrl } from "../../lib/api";

export function Logo({ className = "w-6 h-6" }) {
  return (
    <svg className={`${className} text-[var(--brand)]`} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M12 6v12M6 12h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default function Header({ storeName, logoUrl }) {
  const { count, openCart } = useCart();
  const logoSrc = logoUrl ? resolveImageUrl(logoUrl) : "/logo.png";

  return (
    <header className="sticky top-0 z-40 bg-[var(--site-bg)]/90 backdrop-blur-md border-b border-[#E8E2D9]">
      <nav className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between" aria-label="Navegação Principal">
        <a href="#" data-testid="brand-logo-link" className="flex items-center" aria-label={storeName}>
          <img src={logoSrc} alt={storeName} className="h-10 w-auto" />
        </a>
        <div className="flex items-center gap-6 text-sm">
          <a href="#catalogo" data-testid="nav-catalogo-link" className="hidden sm:inline font-mono text-xs uppercase tracking-wider hover:text-[var(--brand)] transition-colors">
            Catálogo
          </a>
          <a href="#diferenciais" data-testid="nav-sobre-link" className="hidden sm:inline font-mono text-xs uppercase tracking-wider hover:text-[var(--brand)] transition-colors">
            Sobre
          </a>
          <button
            type="button"
            onClick={openCart}
            data-testid="cart-open-button"
            className="flex items-center gap-2 bg-[var(--brand)] text-white px-4 py-2 rounded-full font-display text-xs uppercase tracking-wider font-medium hover:bg-[var(--brand-dark)] transition-colors"
          >
            <ShoppingBag className="w-4 h-4" />
            <span>Sacola ({count})</span>
          </button>
        </div>
      </nav>
    </header>
  );
}

export function WhatsAppIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.19 8.19 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01" />
    </svg>
  );
}

export function buildWhatsAppLink(whatsappNumber, message) {
  const phone = (whatsappNumber || "").replace(/\D/g, "");
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
